<template>
  <div id="searchList">
    <el-form v-if="searchForm" :model="searchForm"
             :inline="true" :size="size"
             ref="searchRef" label-position="top" label-width="100px"
             @submit.native.prevent>
             <!-- @submit.native.prevent 解决 form 只存在一个输入框时，回车刷新页面的问题 -->
      <div class="top-filter" v-if="!hideFuzzySearch">
        <div v-if="!hideFuzzySearch">
          <el-button v-if="searchCondition.length > 0" :size="size" style="margin-right: 30px;vertical-align: top;" @click="onShowConditionClick">
            <span style="margin-right: 10px;">{{
                $t('message.searchCommon.moreOptions')
              }}</span><i
            :class="['el-icon-arrow-down', +collapseActiveNames[0] === 1?'arrow-rotate':'arrow-default']"></i>
          </el-button>
          <el-form-item class="single-input-box fuzzy-input-box">
            <RhcnFuzzyInput :multiple="fuzzySearchMutiple"
              :placeholder="fuzzySearchPlaceholder"
              :size="size"
              @enter="onFuzzySearchInputEnt"
              v-model="searchForm[fuzzySearchKey]"
              :count="fuzzySearchLength"></RhcnFuzzyInput>
          </el-form-item>
        </div>
        <div>
          <template v-for="(item, index) of showSearchButtons">
            <template v-if="index < searchButtonMaxNum">
              <el-form-item :key="'btn'+index">
                <el-button v-if="searchButtons[item].type === 'add'"
                        icon="el-icon-plus" :size="size" type="primary"
                        @click="searchButtons[item].func?searchButtons[item].func(getSearchJson()):null">
                  {{ searchButtons[item].name ? $t(searchButtons[item].name) : $t('message.common.add') }}
                </el-button>
                <el-button v-if="searchButtons[item].type === 'download'"
                          icon="iconfont icon-Download" :size="size"
                          @click="searchButtons[item].func?searchButtons[item].func(getSearchJson()):null">
                  {{ searchButtons[item].name ? $t(searchButtons[item].name) : $t('message.common.download') }}
                </el-button>
                <el-button v-if="searchButtons[item].type === 'other'"
                          :size="size" :type="searchButtons[item].buttonType || 'primary'"
                          :icon="searchButtons[item].icon || ''"
                          @click="searchButtons[item].func?searchButtons[item].func(getSearchJson()):null">
                  {{ searchButtons[item].name ? $t(searchButtons[item].name) : '' }}
                </el-button>
              </el-form-item>
            </template>
          </template>
          <template v-if="showSearchButtons.length > searchButtonMaxNum">
            <el-form-item>
              <el-dropdown trigger="click" placement="bottom-start">
                <span class="el-dropdown-link operations-wrapper">
                  <el-button class="search-buttons-dropdown">
                    <i class="el-icon-more"></i>
                  </el-button>
                </span>
                <template slot="dropdown">
                  <el-dropdown-menu class="operations-dropdown">
                    <p class="operation-title">{{$t('message.tableCommon.operation')}}</p>
                    <template v-for="(item, index) in showSearchButtons">
                      <template v-if="index >= searchButtonMaxNum">
                        <el-dropdown-item :key="'btn' + index">
                          <el-button :size="size" type="text"
                                    @click="searchButtons[item].func?searchButtons[item].func(getSearchJson()):null">
                            {{ searchButtons[item].name ? $t(searchButtons[item].name) : '' }}
                          </el-button>
                        </el-dropdown-item>
                      </template>
                    </template>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </el-form-item>
          </template>
        </div>
      </div>
      <el-collapse v-if="searchCondition.length > 0" v-model="collapseActiveNames">
        <el-collapse-item title="" name="1">
          <div :style="hideFuzzySearch ? 'display:flex;align-items:flex-end;justify-content:space-between;' : ''">
            <div>
              <template v-for="( item , index ) of searchCondition">
                <el-form-item :label="$t(item.name)" v-if="item.type === 'input' && !item.isHide"
                              :key="index"
                              class="single-input-box">
                  <el-input :placeholder="item.placeholder?$t(item.placeholder):''"
                            :size="size"
                            v-model="searchForm[item.key]"
                            @click.native="item.handleClick?item.handleClick($event):null"
                            ></el-input>
                </el-form-item>
                <el-form-item :label="$t(item.name)" v-if="item.type === 'select' && !item.isHide"
                              class="single-input-box"
                              :key="index">
                              <template slot="label">
                                <div v-if="item.titleToolTips">
                                  <span>{{ $t(item.name) }}</span>
                                  <el-tooltip effect="dark" placement="top" :visible-arrow="false">
                                    <div slot="content">{{ $t(item.titleToolTips) }}</div>
                                    <i style="margin-left: 4px;" class="el-icon-warning-outline" :class="item.titleToolTipsKey"></i>
                                  </el-tooltip>
                                </div>
                                <div v-else>
                                  {{ $t(item.name) }}
                                </div>
                              </template>
                  <el-select v-model="searchForm[item.key]"
                            filterable
                            v-if="item.options"
                            clearable
                            style="width: 100%"
                            :multiple="item.multiple"
                            :collapse-tags="true"
                            :size="size"
                            :placeholder="item.placeholder?$t(item.placeholder):''"
                            @click.native="item.handleClick?item.handleClick($event):null"
                            @change="item.changeValue?item.changeValue($event):null">
                    <!-- 自定义label, value字段的key -->
                    <template v-if="item.customOptions && item.options">
                      <el-option v-for="(p , i ) of item.options"
                                :key="i+''"
                                :label="p[item.customOptions.label]"
                                :value="p[item.customOptions.value]">
                      </el-option>
                    </template>
                    <!-- label, value字段没有自定义 -->
                    <template v-if="!item.customOptions && item.options">
                      <el-option v-for="(p , i ) of item.options"
                                :key="i+''"
                                :label="item.isInternationalization||p.isInternationalization?$t(p.label?p.label:p.text):p.label?p.label:p.text"
                                :value="p.value">
                      </el-option>
                    </template>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t(item.name)" v-if="item.type === 'date_time' && !item.isHide"
                              class="double-input-box"
                              :key="index">
                  <div style="display:flex;justify-content: space-between;width: 100%;background-color:#F1F5F7">
                    <RhcnDatepicker v-model="searchForm[getTimeName(item,0)]"
                                    :size="size"
                                    :type="item.dateType || 'datetime'"
                                    :format="item.dateFormat || 'yyyy-MM-dd HH:mm:ss'"
                                    :value-format="item.dateValueFormat"
                                    popper-class="date-picker-class"
                                    :placeholder="item.placeholder&&item.placeholder[0]?$t(item.placeholder[0]):$t('message.searchCommon.startTime')"
                                    :picker-options="item.pickerOptions&&item.pickerOptions[0]"
                                    @input="startTimeChange(item,$event)"
                                    @click="item.handleClick?item.handleClick($event):null"
                                    >
                    </RhcnDatepicker>
                    <i class="el-icon-minus" style="line-height: 32px"></i>
                    <RhcnDatepicker v-model="searchForm[getTimeName(item,1)]"
                                    :size="size"
                                    :type="item.dateType || 'datetime'"
                                    popper-class="date-picker-class"
                                    :format="item.dateFormat || 'yyyy-MM-dd HH:mm:ss'"
                                    :value-format="item.dateValueFormat || 'yyyy-MM-dd HH:mm:ss'"
                                    :placeholder="item.placeholder&&item.placeholder[1]?$t(item.placeholder[1]):$t('message.searchCommon.endTime')"
                                    :picker-options="item.pickerOptions&&item.pickerOptions[1]"
                                    @focus="isEndTimeOpen($event,searchForm[getTimeName(item,1)],item)"
                                    @click="item.handleClick?item.handleClick($event):null"
                                    @input="endTimeChange(item,$event)">
                    </RhcnDatepicker>
                  </div>
                </el-form-item>
                <el-form-item :label="$t(item.name)" v-if="item.type === 'date' && !item.isHide"
                  class="single-input-box"
                  :key="index">
                  <RhcnDatepicker v-model="searchForm[item.key]"
                                  :size="size"
                                  class="single-date-picker"
                                  :type="item.dateType"
                                  :format="item.dateFormat || 'yyyy-MM-dd HH:mm:ss'"
                                  :value-format="item.dateValueFormat || 'yyyy-MM-dd HH:mm:ss'"
                                  popper-class="date-picker-class"
                                  :placeholder="item.placeholder?$t(item.placeholder):$t('message.searchCommon.startTime')"
                                  :picker-options="item.pickerOptions"
                                  @click="item.handleClick?item.handleClick($event):null"></RhcnDatepicker>
                </el-form-item>
                <el-form-item :label="$t(item.name)" v-if="item.type === 'input_range_two' && !item.isHide"
                              class="double-input-box"
                              :key="index">
                  <div style="display:flex;justify-content: space-between;width: 100%">
                    <!--            :placeholder="$t('common.startDate')"-->
                    <el-input
                      :maxlength="item.inputRange&&item.inputRange.strLength&&item.inputRange.strLength[0]"
                      :placeholder="item.inputRange&&item.inputRange.placeholders[0]?$t(item.inputRange.placeholders[0]):''"
                      :size="size"
                      v-model="searchForm[getTimeName(item,0)]"
                      @click.native="item.handleClick?item.handleClick($event):null"></el-input>
                    <i class="el-icon-minus" style="line-height: 32px"></i>
                    <el-input
                      :maxlength="item.inputRange&&item.inputRange.strLength&&item.inputRange.strLength[1]"
                      :placeholder="item.inputRange&&item.inputRange.placeholders[1]?$t(item.inputRange.placeholders[1]):''"
                      :size="size"
                      v-model="searchForm[getTimeName(item,1)]"
                      @click.native="item.handleClick?item.handleClick($event):null"></el-input>
                  </div>
                </el-form-item>
              </template>
            </div>
            <!-- 没有更多搜索条件是的搜索按钮 -->
            <div v-if="hideFuzzySearch">
              <el-form-item v-for="(buttonItem , index) of searchButtons" :key="'btn'+index">
                <!-- button有权限控制 -->
                <template v-if="buttonItem.permissionCode">
                  <el-button v-permission="buttonItem.permissionCode" v-if="buttonItem.type === 'add'"
                            icon="el-icon-plus" :size="size" type="primary"
                            @click="buttonItem.func?buttonItem.func(getSearchJson()):null">
                    {{ buttonItem.name ? $t(buttonItem.name) : $t('message.common.add') }}
                  </el-button>
                  <el-button v-permission="buttonItem.permissionCode" v-if="buttonItem.type === 'download'"
                            icon="iconfont icon-Download" :size="size"
                            @click="buttonItem.func?buttonItem.func(getSearchJson()):null">
                    {{ buttonItem.name ? $t(buttonItem.name) : $t('message.common.download') }}
                  </el-button>
                  <el-button v-permission="buttonItem.permissionCode" v-if="buttonItem.type === 'other'"
                            :size="size" :type="buttonItem.buttonType || 'primary'"
                            @click="buttonItem.func?buttonItem.func(getSearchJson()):null">
                    {{ buttonItem.name ? $t(buttonItem.name) : '' }}
                  </el-button>
                </template>
                <!-- button没有权限控制 -->
                <template v-else>
                  <el-button v-if="buttonItem.type === 'add'"
                            icon="el-icon-plus" :size="size" type="primary"
                            @click="buttonItem.func?buttonItem.func(getSearchJson()):null">
                    {{ buttonItem.name ? $t(buttonItem.name) : $t('message.common.add') }}
                  </el-button>
                  <el-button v-if="buttonItem.type === 'download'"
                            icon="iconfont icon-Download" :size="size"
                            @click="buttonItem.func?buttonItem.func(getSearchJson()):null">
                    {{ buttonItem.name ? $t(buttonItem.name) : $t('message.common.download') }}
                  </el-button>
                  <el-button v-if="buttonItem.type === 'other'"
                            :size="size" :type="buttonItem.buttonType || 'primary'"
                            :icon="buttonItem.icon || ''"
                            @click="buttonItem.func?buttonItem.func(getSearchJson()):null">
                    {{ buttonItem.name ? $t(buttonItem.name) : '' }}
                  </el-button>
                </template>
              </el-form-item>
            </div>
          </div>
          <div class="bottom-box">
            <el-form-item>
              <template v-if="permissionCode">
                <el-button v-permission="permissionCode" type="primary" :size="size" @click="onSearch">
                  {{ $t('message.searchCommon.search') }}
                </el-button>
              </template>
              <template v-else>
                <el-button type="primary" :size="size" @click="onSearch">{{
                    $t('message.searchCommon.search')
                  }}
                </el-button>
              </template>
              <template v-if="isDisplayReset">
                <el-button type="normal" @click="onReset" :size="size">{{$t('message.common.reset')}}</el-button>
              </template>
              <template v-if="!hideFuzzySearch">
                <span class="stow-button" @click="onCloseConditionClick">{{
                    $t('message.searchCommon.stowOptions')
                  }}
                </span>
              </template>
            </el-form-item>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-form>
  </div>
</template>
<script>
import RhcnDatepicker from '@/components/form/datepicker.vue';
import { ShowErrorMessage } from '@/components/modal/tips/message-tips';
import RhcnFuzzyInput from '@/components/table/components/fuzzy-input.vue';
import { SEARCH_GET_NAME, SEARCH_GET_TITLE_SEARCH_VALUE, SEARCH_SET_NAME } from '@/store/modules/search';
import { initSelectedData } from '@/utils/tools/constant';
import { formatDate, formatDateDisplay } from '@/utils/tools/time.js';
import { comparisonObject, isNullForDisplay, isNullForTransferValue } from '@/utils/tools/utils.js';

export default {
  name: 'SearchComponent',
  components: {
    RhcnDatepicker,
    RhcnFuzzyInput,
  },
  props: {
    /**
     * 权限控制
     */
    permissionCode: String,
    /**
     * 搜索条件模板
     */
    searchCondition: {
      type: Array,
      default: () => [],
    },
    searchButtons: {
      type: Array,
      default: () => [],
    },
    /**
     * 时间搜索框的默认搜索格式
     */
    datePickerFormat: {
      type: String,
      default: 'yyyy-MM-dd HH:mm:ss',
    },
    /**
     * 用于沟通Table组件(和Table里面的routerName保持一致)
     */
    routerName: {
      type: String,
      default: '',
    },
    /**
     * 需要搜索按钮和搜索条件同排显示时传入true
     */
    isJudgmentTime: Boolean,
    /**
     * 用于查询之前的条件判断
     */
    validFunction: {
      type: Function,
      default: null,
    },
    /**
     * 主要输入框的参数
     */
    filterMainInputKey: {
      type: String,
      default: 'mainInput',
    },
    /**
     * 主要输入框的参数
     */
    filterMainSelectKey: {
      type: String,
      default: 'mainSelect',
    },
    /**
     * 主要输入框的参数
     */
    filterMainSelectOption: {
      type: Array,
      default: () => [{ label: 'abc', value: '123' }],
    },
    size: {
      type: String,
      default: 'small',
    },
    fuzzySearchPlaceholder: {
      type: String,
      default: '',
    },
    fuzzySearchKey: {
      type: String,
      default: 'keywords',
    },
    // 是否显示搜索数量
    showFilterNumber: {
      type: Boolean,
      default: true,
    },
    // 隐藏联合搜索
    hideFuzzySearch: {
      type: Boolean,
      default: false,
    },
    // 联合搜索是否支持多个
    fuzzySearchMutiple: {
      type: Boolean,
      default: false,
    },
    // 联合搜索的最大数量
    fuzzySearchLength: {
      type: Number,
      default: 50,
    },
    // 显示商户号搜索条件
    showMerchantSearch: {
      type: Boolean,
      default: false,
    },
    isDisplayReset: {
      type: Boolean,
      default: false,
    },
    searchButtonMaxNum: {
      type: Number,
      default: 2,
    },
  },
  data() {
    return {
      searchForm: {},
      collapseActiveNames: [''],
      collapseFilterLength: 0,
      fuzzySearchRows: 1,
      showSearchButtons: [],
    };
  },
  methods: {
    onShowConditionClick() {
      this.collapseActiveNames = +this.collapseActiveNames[0] === 1 ? [''] : ['1'];
    },
    onCloseConditionClick() {
      this.collapseActiveNames = [''];
    },
    getTimeName(item, index) {
      return item.key[index];
    },
    initForm() {
      const obj = {};
      this.searchCondition.forEach((item) => {
        if (item.type === 'date_time') {
          obj[this.getTimeName(item, 0)] = item.defValue && item.defValue[0] ? formatDate(item.defValue[0], (item.dateValueFormat || this.datePickerFormat)) : null;
          obj[this.getTimeName(item, 1)] = item.defValue && item.defValue[1] ? formatDate(item.defValue[1], (item.dateValueFormat || this.datePickerFormat)) : null;
          item.pickerOptions = item.pickerOptions ||
            [{ disabledDate: this.genDisabledStarFunc(item.key[1], item.dateType) }, { disabledDate: this.genDisabledEndFunc(item.key[0], item.dateType) }];
        } else {
          obj[item.key] = item.defValue;
        }
      });

      if (!this.hideFuzzySearch) {
        obj[`${this.fuzzySearchKey}`] = undefined;
      }
      return obj;
    },
    /* ---------------------------------------时间控件---------------------------------- */
    // 禁选开始的时间
    disabledDateStar(currDate, targetDateKey, dateType) {
      if (this.searchForm[targetDateKey]) {
        const endTime = formatDate(this.searchForm[targetDateKey]);
        if (!dateType || dateType === 'date') {
          endTime.setDate(endTime.getDate() - 90);
        } else if (dateType === 'month') {
          endTime.setDate(1);
          endTime.setHours(0);
          endTime.setMinutes(0);
          endTime.setSeconds(0);
          endTime.setMonth(endTime.getMonth() - 11);
        }
        return currDate.getTime() > formatDate(this.searchForm[targetDateKey]).getTime() || currDate.getTime() < endTime.getTime();
      }
      return false;
    },
    // 禁选结束的时间
    disabledDateEnd(currDate, targetDateKey, dateType) {
      if (this.searchForm[targetDateKey]) {
        const startTime = formatDate(this.searchForm[targetDateKey]);
        if (!dateType || dateType === 'date') {
          startTime.setDate(startTime.getDate() + 89);
          if (dateType === 'date') {
            startTime.setHours(0);
            startTime.setMinutes(0);
            startTime.setSeconds(0);
          }
        } else if (dateType === 'month') { // 12个月
          startTime.setDate(1);
          startTime.setHours(0);
          startTime.setMinutes(0);
          startTime.setSeconds(0);
          startTime.setMonth(startTime.getMonth() + 12);
        }
        const endTime = formatDate(this.searchForm[targetDateKey]);
        endTime.setHours(0);
        endTime.setMinutes(0);
        endTime.setSeconds(0);
        return currDate.getTime() < endTime.getTime() || currDate.getTime() >= startTime.getTime();
      }
      return false;
    },
    genDisabledStarFunc(dateKey, dateType) {
      return (curr) => this.disabledDateStar(curr, dateKey, dateType);
    },
    genDisabledEndFunc(dateKey, dateType) {
      return (curr) => this.disabledDateEnd(curr, dateKey, dateType);
    },
    // 开始时间变动
    startTimeChange(item) {
      const startDate = this.searchForm[this.getTimeName(item, 0)];
      const endDate = this.searchForm[this.getTimeName(item, 1)];
      if ((!item.dateValueFormat || /^yyyy-MM-dd HH:mm:ss$/.test(item.dateValueFormat)) && startDate && endDate) {
        const sDate = formatDate(startDate);
        const eDate = formatDate(endDate);
        if (sDate > eDate) {
          this.searchForm[this.getTimeName(item, 0)] = eDate;
        }
      }
    },
    endTimeChange(item) {
      // const endDate = this.searchForm[this.getTimeName(item, 1)];
      // if ((!item.dateValueFormat || /^yyyy-MM-dd HH:mm:ss$/.test(item.dateValueFormat)) && endDate) {
      //   endDate.setHours(23, 59, 59);
      // }
      const startDate = this.searchForm[this.getTimeName(item, 0)];
      const endDate = this.searchForm[this.getTimeName(item, 1)];
      if ((!item.dateType || item.dateType === 'datetime') && startDate && endDate) {
        const sDate = formatDate(startDate);
        const eDate = formatDate(endDate);
        if (eDate < sDate) {
          this.searchForm[this.getTimeName(item, 1)] = sDate;
        }
      }
    },
    isEndTimeOpen(focus, event, item) {
      if ((!item.dateValueFormat || /^yyyy-MM-dd HH:mm:ss$/.test(item.dateValueFormat)) && !this.searchForm[this.getTimeName(item, 1)]) {
        if (this.searchForm[this.getTimeName(item, 0)]) {
          const time = formatDate(this.searchForm[this.getTimeName(item, 0)]);
          time.setHours(23, 59, 59);
          this.searchForm[this.getTimeName(item, 1)] = time;
        } else {
          const time = new Date();
          time.setHours(23, 59, 59);
          this.searchForm[this.getTimeName(item, 1)] = time;
        }
      }
    },
    /* ---------------------------------------时间控件---------------------------------- */
    onReset() {
      this.searchForm = this.initForm();
      this.onSearch();
    },

    // 重置查询条件
    resetForm() {
      this.searchForm = this.initForm();
    },

    getSearchJson() {
      const params = {};
      const object = this.searchForm;
      Object.keys(object).forEach((item) => {
        if (isNullForTransferValue(object[item])) {
          const searchItem = this.getSearchItem(item);
          if (item.toLowerCase().indexOf('time') > -1 ||
            item.toLowerCase().indexOf('date') > -1) {
            params[item] = searchItem.timeFormatFunc ? searchItem.timeFormatFunc(item, object[item])
              : formatDateDisplay(object[item], (searchItem.dateValueFormat || this.datePickerFormat));
          } else if (searchItem && searchItem.type === 'select' && searchItem.multiple) {
            params[item] = typeof object[item] === 'object' ? object[item].join(',') : object[item];
          } else {
            params[item] = (typeof object[item] === 'string') ? object[item].trim() : object[item];
          }
        }
      });
      return params;
    },
    onSearch() {
      if (this.routerName) {
        const params = this.getSearchJson();
        if (this.validFunction) {
          const valid = this.validFunction(params);
          if (!valid) {
            return;
          }
        }
        let hasStartTime = false;
        let hasEntTime = false;
        for (let i = 0; i < this.searchCondition.length; i++) {
          const item = this.searchCondition[i];
          if (item.type === 'date_time') {
            if (item.key[0] === 'startTime') hasStartTime = true;
            if (item.key[1] === 'endTime') hasEntTime = true;
            if (item.key[0] !== 'startTime' && item.required) { // 为了不影响原有的startTime, endTime, 添加 item.key[0] !== 'startTime' 判断
              if (!params[item.key[0]]) {
                ShowErrorMessage(this.$t('message.searchCommon.startTimeTip', { time: this.$t(item.name) }));
                return;
              }
            }
            if (item.key[1] !== 'endTime' && item.required) { // 为了不影响原有的startTime, endTime, 添加 item.key[0] !== 'endTime' 判断
              if (!params[item.key[1]]) {
                ShowErrorMessage(this.$t('message.searchCommon.endTimeTip', { time: this.$t(item.name) }));
                return;
              }
            }
          }
        }
        if (this.isJudgmentTime) {
          if (hasStartTime && !params.startTime) {
            ShowErrorMessage(this.$t('message.searchCommon.startTimeTip', { time: this.$t(this.getSearchItem('startTime').name) }));
            return;
          }
          if (hasEntTime && !params.endTime) {
            ShowErrorMessage(this.$t('message.searchCommon.endTimeTip', { time: this.$t(this.getSearchItem('endTime').name) }));
            return;
          }
        }
        this.sendQueryCriteria(params);
      } else {
        this.$emit('toSearch', this.getSearchJson());
      }
    },
    sendQueryCriteria(params) {
      this.collapseFilterLength = Object.keys(params).length;
      this.$store.commit(SEARCH_SET_NAME, {
        name: this.routerName,
        value: params,
        time: formatDate(new Date()),
      });
    },
    /**
     * 获取条件的条目
     */
    getSearchItem(key) {
      let conditionItem = null;
      this.searchCondition.forEach((item) => {
        if ((item.type === 'date_time') && (item.key[0] === key || item.key[1] === key)) {
          conditionItem = item;
        } else if (item.key === key) {
          conditionItem = item;
        }
      });
      return conditionItem;
    },
    /**
     * 通过网络获取选择框的值
     */
    setSearchSelectOptions(key, array) {
      this.getSearchItem(key).options = array;
      this.$forceUpdate();
    },
    /**
     * 设置input的值
     */
    setInputValue(key, value) {
      this.searchForm[key] = value;
    },

    /**
     * 获取input的值
     */
    getInputValue(key) {
      return this.searchForm[key];
    },
    /**
     * 赋值初始化
     */
    assignmentFormValue(data) {
      Object.keys(this.searchForm).forEach((item) => {
        const searchItem = this.getSearchItem(item);
        if (searchItem && !data[item] && comparisonObject({}, data) && searchItem.defValue) {
          if (searchItem.type === 'date_time') {
            if (item === searchItem.key[0]) {
              this.setInputValue(item, searchItem.defValue[0]);
            } else {
              this.setInputValue(item, searchItem.defValue[1]);
            }
          }
        } else {
          if (searchItem && searchItem.type === 'date_time' && data[item]) {
            this.setInputValue(item, formatDate(data[item]));
          } else if (searchItem && searchItem.type === 'select' && searchItem.multiple) {
            if (data[item]) {
              this.setInputValue(item, typeof data[item] === 'string' ? data[item].split(',') : data[item]);
            } else {
              this.setInputValue(item, []);
            }
          } else {
            this.setInputValue(item, isNullForDisplay(data[item]));
          }
        }
      });
    },
    onFuzzySearchInputEnt() {
      this.onSearch();
    },
    /**
     * 调整表格
     */
    onSearchTitleListens() {
      if (this.$store.getters[SEARCH_GET_NAME] === this.routerName) {
        const array = this.$store.getters[SEARCH_GET_TITLE_SEARCH_VALUE];
        if (array && array.length > 0) {
          this.searchCondition.forEach(item => {
            const titleValue = array.find(subItem => item.key === subItem.titleSearchKey);
            if (titleValue) {
              if (+titleValue.queryDisplayValue === 1) {
                this.searchForm[item.key] = '';
                this.onSearch();
              } else if (+titleValue.queryDisplayValue === 2) {
                // this.searchForm[item.key] = '';
                // item.isHide = true;
              } else {

              }
            }
          });
        }
      }
    },
    initSearchButtons() {
      // 获取有权限的按钮
      if (this.searchButtons) {
        this.showSearchButtons = [];
        this.searchButtons.forEach((item, idx) => {
          if (item.permissionCode) {
            const pagePermission = this.$store.getters.permission.permissionCodes;
            if ((pagePermission && pagePermission.includes(item.permissionCode)) && (!item.isDisplayFunc || item.isDisplayFunc())) {
              this.showSearchButtons.push(idx);
            }
          } else if ((!item.isDisplayFunc || item.isDisplayFunc())) {
            this.showSearchButtons.push(idx);
          }
        });
      }
    },
  },
  watch: {
    '$store.state.search.titleSearchTime': 'onSearchTitleListens',
    $route: function(to, from) {
      const count = setTimeout(() => {
        this.assignmentFormValue(this.$route.query);
        clearTimeout(count);
      }, 500);
    },
  },
  mounted() {
    if (this.hideFuzzySearch) {
      this.collapseActiveNames = ['1']; // 隐藏联合搜索时，显示详细
    }

    try {
      const userLogin = this.$store.getters.app.userLogin;
      // 是否是集团商户
      const isGroupMerchant = `${userLogin.merchantType}` === '3';
      if (isGroupMerchant && this.showMerchantSearch) {
        const merchantNoList = userLogin.merchantNoList || [];
        this.searchCondition.unshift({
          key: 'merchantNo',
          name: 'message.account.merchantNo',
          type: 'select',
          defValue: '',
          options: initSelectedData(merchantNoList, '', ''),
        });
      }
    } catch (err) {
      //
    }

    this.searchForm = this.initForm();
    if (this.$route.query) {
      const count = setTimeout(() => {
        this.assignmentFormValue(this.$route.query);
        clearTimeout(count);
      }, 500);
    }
    this.initSearchButtons();
  },
};
</script>
<style lang="scss">
@import '@/styles/variables.scss';

#searchList {
  text-align: left;

  .el-collapse-item__wrap {
    border-bottom: none;
  }

  .el-form-item {
    margin-bottom: 15px;
  }

  .single-input-box {
    width: 300px;

    .el-input__inner {
      height: 32px !important;
    }
  }

  .double-input-box {
    width: 300px;
  }

  .single-date-picker {
    width: 100%;
  }

  .fuzzy-input-box {
    .fuzzy-search-icon {
      cursor: pointer;
      width: 100%;
      // height: 100%;
    }
  }

  .search-buttons-dropdown {
    width: 20px;
    height: 30px;
    min-width: 0;
    .el-icon-more {
      margin: 0;
      transform: rotate(90deg);
    }
  }

  .single-input-box, .double-input-box, .el-date-editor {
    margin-right: 30px;
  }

  .top-filter {
    height: 32px;
    margin-bottom: 18px;
    display: flex;
    justify-content: space-between;

    .icon-Download {
      font-size: 12px;
      margin-right: 5px;
    }
  }

  .el-collapse-item__header {
    display: none;
  }

  .el-collapse-item__content {
    padding: 0px;
  }

  .el-collapse {
    border: 0px;
  }

  .arrow-default {
    transition: all .3s;
  }

  .arrow-rotate {
    transform: scale(0.73) rotate(-180deg) !important;
    transition: all .3s;
  }

  .stow-button {
    width: 90px;
    height: 30px;
    font-size: 14px;
    font-weight: 800;
    color: $color-primary;
    line-height: 30px;
    margin-left: 38px;
    cursor: pointer;
  }

  .bottom-box {
    margin-top: 5px;
  }
}

.date-picker-class > .el-picker-panel__footer > .el-button--text:first-child {
  display: none;
}

.el-select__tags-text {
  display: inline-block;
  max-width: 135px;
}
</style>
